import React, { useState } from 'react';
import './ComingSoon.css';

const ComingSoon = ({ onPasscodeSubmit }) => {
  const [passcode, setPasscode] = useState('');
  const [showPasscodeInput, setShowPasscodeInput] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onPasscodeSubmit(passcode);
    setPasscode(''); // Clear the input after submission
  };

  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        {/* Logo */}
        <div className="logo-container">
          <img 
            src="/press-peels-logo-trimmed.svg" 
            alt="Press Peels Logo" 
            className="logo"
          />
        </div>
        
        {/* Main Message */}
        <h1 className="coming-soon-title">Press Peels</h1>
        <h2 className="coming-soon-subtitle">Coming Soon</h2>
        
        <p className="coming-soon-description">
          We're putting the finishing touches on something amazing. 
          Get ready for premium custom press peels that will transform your creative projects.
        </p>
        
        {/* Features Preview */}
        <div className="features-preview">
          <div className="feature">
            <span className="feature-icon">🎨</span>
            <span>Custom Designs</span>
          </div>
          <div className="feature">
            <span className="feature-icon">⚡</span>
            <span>Fast Turnaround</span>
          </div>
          <div className="feature">
            <span className="feature-icon">✨</span>
            <span>Premium Quality</span>
          </div>
        </div>
        
        {/* Access Button/Form */}
        {!showPasscodeInput ? (
          <button 
            className="access-button"
            onClick={() => setShowPasscodeInput(true)}
          >
            Team Access
          </button>
        ) : (
          <form onSubmit={handleSubmit} className="passcode-form">
            <div className="passcode-input-container">
              <input
                type="password"
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
                placeholder="Enter passcode"
                className="passcode-input"
                autoFocus
              />
              <button type="submit" className="passcode-submit">
                Enter
              </button>
            </div>
            <button 
              type="button" 
              className="cancel-button"
              onClick={() => {
                setShowPasscodeInput(false);
                setPasscode('');
              }}
            >
              Cancel
            </button>
          </form>
        )}
      </div>
      
      {/* Footer */}
      <footer className="coming-soon-footer">
        <p>&copy; 2024 Press Peels. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ComingSoon; 